<template>
    <div>
        <tooltip/>
        <vue-snotify></vue-snotify>

        <div class="label-row mt-5">
            <div class="refresh-button">
                <h4 class="big-title">Transaction History</h4>
                <button class="btn btn-outline-secondary" @click="$emit('refreshTable')">Refresh</button>
            </div>

            <div class="filter-buttons">
                <slot></slot>
            </div>
        </div>

        <table class="messages-table">
            <tr>
                <th>Phone number</th>
                <th>Provider</th>
                <th>Date and time</th>
                <th>Keyword</th>
                <th>Status</th>
                <th v-if="showServiceResponse()">Service response</th>
                <th>Generated code</th>
                <th>Code Used</th>
                <th>Value</th>
                <th>Actions</th>
            </tr>
            <tr v-if="!pagination.data">
                <th colspan="6">
                    <span class="loader-icon"></span>
                </th>
            </tr>
            <tr v-if="pagination.data" @click="$emit('numberHistory', message)" v-for="(message, index) in pagination.data" :key="message.id">
                <td>{{ message.from }}</td>
                <td><img :src="providerLogo(message.provider_id)"></td>
                <td>{{ message.created_at }}</td>
                <td>{{ message.keyword.name }}</td>

                <td v-if="!showServiceResponse()" :class="message.status === 'OK' ? 'status-column' : ''" v-popover:tooltip.left="formatServiceResponse(message.service_response)">{{ message.status }}</td>

                <template v-else>
                    <td :class="message.status === 'OK' ? 'status-column' : ''">{{ message.status }}</td>
                    <td>{{ formatServiceResponse(message.service_response) }}</td>
                </template>

                <td v-if="message.status === 'OK' && !message.generated_code || message.generated_code === ' '"><button style="z-index: 100;" class="btn btn-outline-primary" @click.stop="$emit('generateCode', message)">Generate</button></td>
                <td v-else>{{ message.generated_code }}</td>
                <td v-popover:tooltip.left="function(){return message.code_used_date ? message.code_used_date : 'Not used'}()">{{ message.code_used ? 'YES' : 'NO'}}</td>

                <td>{{ message.amount }} KM</td>

                <td><button @click.stop="resendCode(message)" v-if="message.provider_id === 2" style="z-index: 100;" class="btn btn-outline-danger">Resend Code</button></td>
            </tr>
        </table>

        <pagination :data="pagination" @pagination-change-page="$emit('pageChanged', $event)" align="center" :limit="3"></pagination>
    </div>
</template>

<script>
    export default {
        name: "Table",
        props: ['pagination'],
        methods: {
            showServiceResponse() {
                return window.location.href.split('?').pop() === 'response=true'
            },
            resendCode(message) {
                if(confirm('Are you sure?')) {
                    this.$emit('resendCode', message)
                }
            }
        }
    }
</script>

<style scoped>
    .refresh-button {
        display: flex;
    }

    .refresh-button button {
        width: 130px;
        height: 32px;
        padding: 0;
        margin-left: 10px;
        box-shadow: none;
    }

    .filter-buttons {
        display: flex;
        justify-content: space-around;
    }

    .filter-buttons div {
        padding: 0 10px;
    }

    table {
        width: 100%;
    }

    th {
        font-family: Roboto, Bold, sans-serif;
        background: #F5F6FA;
        padding: 15px 20px;
        text-transform: uppercase;
        font-size: 12px;
        font-weight: bold;
        text-align: left;
        letter-spacing: 0.41px;
        color: #87878A;
        opacity: 1;
    }

    td {
        padding: 20px 20px;
        font: Normal 15px/20px Source Sans Pro;
        color: #4D4F5C;
        cursor: pointer;
    }

    tr td {
        border-bottom: 1px solid rgba(0, 0, 0, 0.1);
    }

    .pagination {
        margin-top: 20px;
    }

    .pagination >>> .page-item .page-link {
        color: #87878A;
        box-shadow: none;
    }

    .pagination >>> .page-item.active .page-link {
        background-color: #ebecf0;
        border: 1px solid #dee2e6;
    }

    .status-column {
        color: #419AFF;
    }
</style>
